<template>
    <div class="home-container">
        <left-menu></left-menu>
        <div class="main-container-content">
            <el-main>
                <div style="width: 100%">
                    <router-view  :key="randomKey"></router-view>
                </div>
            </el-main>
        </div>
        <ad-banner
                :list="list"
                @close="visible = false"
                :visible.sync="visible">
        </ad-banner>
    </div>
</template>

<script>
    import LeftMenu from "../../components/LeftMenu";
    import AdBanner from "@/components/AdBanner";
    import adApi from '@/api/adData';

    export default {
        name: "home",
        components: {
            LeftMenu,
            AdBanner,
        },
        data() {
            return {
                visible: false,
                list: [],
            }
        },
        computed: {
            randomKey() {
                return  this.$route.path + Math.random();
            }
        },
        methods: {
            async loadAdBanner () {
                let hasShow = sessionStorage.getItem('-_hasAdShow_-');
                if (hasShow && hasShow === 'yes') {
                    return;
                }
                let res = await adApi.getAdList();
                if (res && res.length !== 0) {
                    this.list = res;
                    this.visible = true;
                    sessionStorage.setItem('-_hasAdShow_-', 'yes');
                }
            },
        },

        created() {
            this.loadAdBanner();
        },

        mounted() {

        }
    }
</script>
<style lang="less">
    .el-main {
        background-color: rgb(245, 245, 246);
        padding: 0;
        overflow-y: auto;
        height: 100%;
        &>div {
            height: 100%;
            overflow-y: auto;
            background-color: #FFFFFF;
        }
    }
</style>
<style scoped lang="less">
    .home-container{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        .main-container-content {
            width: 100%;
            height: 100%;
        }
    }

</style>
